import useBootstrapData from '@/hooks/useBootstrapData'
import useClientSideSignedInData from '@/hooks/useClientSideSignedInData'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'

import type { AbandonedSelection, SearchProductList } from '../types'
import useAbandonedSelections from './useAbandonedSelections'

function useTripActivityData(
  productType: SearchProductList,
  abandonedSelectionData?: AbandonedSelection | null,
) {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn: serverSignedIn },
  } = useBootstrapData()

  const { signedIn: clientSideSignedIn } = useClientSideSignedInData()
  const signedIn = serverSignedIn || clientSideSignedIn
  const abandonedSelectionFetched = useAbandonedSelections({
    cguid: clientGUID,
    appName,
    appVersion,
    signedIn,
    productType,
  })

  // when signed in, abandonedSelectionData is passed in as a prop from the parent
  // and we will get the data from useTripGroupings
  const abandonedSelection = abandonedSelectionFetched || abandonedSelectionData

  const { data: recentSearchData } = useRecentSearchCard(
    clientGUID,
    { appName, appVersion },
    productType,
    signedIn,
  )

  return {
    abandonedSelection,
    atMostFiveRecentSearchCards: recentSearchData.slice(0, 5),
  }
}

export default useTripActivityData
